import React from 'react';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { onModalOpen, onChangeDarkMode, onChangeHighcontrast, OnchangeRTLmode } from '../Redux/Actions/Actions';
import { logoutUser } from '../Redux/Actions/authActions';
import Header from '../Component/Comman/Header';
import Dashboard from './Dashboard/Dashboard';
import NewModal from '../Component/Comman/NewModal';
import Market from './Market/Market';
import WalletPage from './WalletPage/WalletPage';
import SecurityPage from './SecurityPage/SecurityPage';
import Identification from './Identification/Identification';
import ReferalPage from './ReferalPage/ReferalPage';
import BankAccountPage from './BankAccountPage/BankAccountPage';
import ProfilePage from './ProfilePage/ProfilePage';
import ForexPage from './ForexPage/ForexPage';
import CryptoPage from './CryptoPage/CryptoPage';
import GoldPage from './GoldPage/GoldPage';
import { getBaseUrl, buildPath } from '../utils/urlHelper';

// Admin Pages
import AdminDashboard from './Admin/Dashboard';
import Users from './Admin/Users';
import TradesList from './Admin/TradesList';
import Transactions from './Admin/Transactions';
import CreateTransaction from './Admin/CreateTransaction';
import ViewTransaction from './Admin/ViewTransaction';
import ForexSymbols from './Admin/ForexSymbols';
import CryptoSymbols from './Admin/CryptoSymbols';
import GoldSymbols from './Admin/GoldSymbols';
import PaymentMethods from './Admin/PaymentMethods';
import KYCList from './Admin/KYCList';
import KYCDetails from './Admin/KYCDetails';
import Settings from './Admin/Settings';
import ChangePassword from './Admin/ChangePassword';
import Agents from './Admin/Agents';
import Banks from './Admin/Banks';
import PagePopups from './Admin/PagePopups';
import PopupForm from './Admin/PopupForm';
import AddUser from './Admin/AddUser';
import ManualTrades from './Admin/ManualTrades';
import AddForexSymbol from './Admin/AddForexSymbol';
import AddCryptoSymbol from './Admin/AddCryptoSymbol';
import AddGoldSymbol from './Admin/AddGoldSymbol';
import AddPaymentMethod from './Admin/AddPaymentMethod';
import EditPaymentMethod from './Admin/EditPaymentMethod';
import PaymentMethodMapping from './Admin/PaymentMethodMapping';
import UserDetails from './Admin/UserDetails';
import EditUser from './Admin/EditUser';

function MainIndex(props) {
    const { modalopen, darkMode, highcontrast, rtlmode } = props.Mainreducer;
    const { activekey, GotoChangeMenu } = props;
    const baseUrl = getBaseUrl();
    return (
        <div className='main px-lg-4 px-md-4'>
            {activekey === "/chat" || activekey === "/documentation" ? "" :
                <Header
                    onModalOpen={(val) => { props.onModalOpen(true) }}
                    GotoChangeMenu={(val) => { GotoChangeMenu(val) }}
                />
            }
            <NewModal
                show={modalopen}
                highcontrast={highcontrast}
                darkMode={darkMode}
                onHide={(val) => { props.onModalOpen(false) }}
                onChangeDarkMode={() => { props.onChangeDarkMode(darkMode === 'dark' ? 'light' : 'dark') }}
                onChangeHighcontrast={() => { props.onChangeHighcontrast(highcontrast === 'high-contrast' ? 'light' : 'high-contrast') }}
                OnchangeRTLmode={() => { props.OnchangeRTLmode(rtlmode === 'rtl_mode' ? true : false) }}
            />
            <div className="body d-flex py-3 ">
                <Routes>
                    <Route exact path={buildPath('/')} element={<Dashboard />} />
                    <Route exact path={buildPath('/market')} element={<Market />} />
                    <Route exact path={buildPath('/wallet-page')} element={<WalletPage />} />
                    <Route exact path={buildPath('/security-page')} element={<SecurityPage />} />
                    <Route exact path={buildPath('/identification')} element={<Identification />} />
                    <Route exact path={buildPath('/refer-page')} element={<ReferalPage />} />
                    <Route exact path={buildPath('/bank-accounts')} element={<BankAccountPage />} />
                    <Route exact path={buildPath('/profile')} element={<ProfilePage />} />
                    <Route exact path={buildPath('/forex')} element={<ForexPage />} />
                    <Route exact path={buildPath('/crypto')} element={<CryptoPage />} />
                    <Route exact path={buildPath('/gold')} element={<GoldPage />} />
                    
                    {/* Admin Routes */}
                    <Route exact path={buildPath('/admin/dashboard')} element={<AdminDashboard />} />
                    <Route exact path={buildPath('/admin/users')} element={<Users />} />
                    <Route exact path={buildPath('/admin/trades-list')} element={<TradesList />} />
                    <Route exact path={buildPath('/admin/transactions')} element={<Transactions />} />
                    <Route exact path={buildPath('/admin/transactions/create')} element={<CreateTransaction />} />
                    <Route exact path={buildPath('/admin/transaction/:id')} element={<ViewTransaction />} />
                    <Route exact path={buildPath('/admin/forex-symbols')} element={<ForexSymbols />} />
                    <Route exact path={buildPath('/admin/crypto-symbols')} element={<CryptoSymbols />} />
                    <Route exact path={buildPath('/admin/gold-symbols')} element={<GoldSymbols />} />
                    <Route exact path={buildPath('/admin/payment-methods')} element={<PaymentMethods />} />
                    <Route exact path={buildPath('/admin/kyc-list')} element={<KYCList />} />
                    <Route exact path={buildPath('/admin/kyc/:id')} element={<KYCDetails />} />
                    <Route exact path={buildPath('/admin/settings')} element={<Settings />} />
                    <Route exact path={buildPath('/admin/change-password')} element={<ChangePassword />} />
                    <Route exact path={buildPath('/admin/agents')} element={<Agents />} />
                    <Route exact path={buildPath('/admin/banks')} element={<Banks />} />
                    <Route exact path={buildPath('/admin/page-popups')} element={<PagePopups />} />
                    <Route exact path={buildPath('/admin/create-popup')} element={<PopupForm />} />
                    <Route exact path={buildPath('/admin/edit-popup/:id')} element={<PopupForm />} />
                    <Route exact path={buildPath('/admin/add-user')} element={<AddUser />} />
                    <Route exact path={buildPath('/admin/manual-trades')} element={<ManualTrades />} />
                    <Route exact path={buildPath('/admin/add-forex-symbol')} element={<AddForexSymbol />} />
                    <Route exact path={buildPath('/admin/add-crypto-symbol')} element={<AddCryptoSymbol />} />
                    <Route exact path={buildPath('/admin/add-gold-symbol')} element={<AddGoldSymbol />} />
                    <Route exact path={buildPath('/admin/add-payment-method')} element={<AddPaymentMethod />} />
                    <Route exact path={buildPath('/admin/edit-payment-method/:id')} element={<EditPaymentMethod />} />
                    <Route exact path={buildPath('/admin/payment-method-mapping')} element={<PaymentMethodMapping />} />
                    <Route exact path={buildPath('/admin/user/:id')} element={<UserDetails />} />
                    <Route exact path={buildPath('/admin/edit-user/:id')} element={<EditUser />} />
                </Routes>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => ({
    Mainreducer: state.Mainreducer,
})
export default connect(mapStateToProps, {
    onModalOpen,
    onChangeDarkMode,
    onChangeHighcontrast,
    OnchangeRTLmode,
    logoutUser
})(MainIndex);